<template>
  <div   v-bind:class='{"app-container":$route.name!=="LandingPage"}'> 

<div v-if="$route.name!=='login-home' && $route.name!=='login-phone' && $route.name!=='LandingPage'" class="header-bar">
  <!-- ===========================
      ロゴ：通常
      ===========================-->
<div  class="mini-title-container">

  <img class="logo" src="./assets/images/logo-kidstthink.svg"  >

  <div class="logo-sub">きっずてぃーしんく</div>
  <!-- <svg class="logo" width="180px"  viewBox="0 0 172 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="ChatApp" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.54">
          <path d="M14.728,3.744 L14.568,2.912 C14.392,1.904 14.312,1.568 14.152,1.104 L17.096,0.656 C17.112,1.152 17.192,1.696 17.32,2.432 L17.496,3.312 L19.992,2.928 C21.128,2.752 21.576,2.672 22.28,2.464 L22.728,5.152 C22.184,5.2 22.184,5.2 20.456,5.456 L17.96,5.84 L18.344,7.856 L21.304,7.408 C22.408,7.232 22.936,7.12 23.608,6.912 L24.088,9.616 C23.176,9.712 23.176,9.712 21.832,9.904 L18.808,10.368 L19.256,12.688 C19.512,14.064 19.544,14.224 19.736,14.832 L16.696,15.328 C16.696,14.784 16.632,14.32 16.408,13.104 L15.992,10.8 L12.824,11.296 C11.72,11.472 11.64,11.488 10.632,11.744 L10.2,9.024 C10.856,8.992 11.528,8.928 12.488,8.768 L15.544,8.288 L15.176,6.272 L12.968,6.624 C11.608,6.832 11.24,6.896 10.584,7.072 L10.152,4.336 C10.856,4.32 11.384,4.256 12.504,4.08 L14.728,3.744 Z M34.16,3.52 L35.152,0.96 C38.688,1.328 40.448,1.664 44.384,2.656 L43.536,5.344 C39.952,4.272 37.616,3.824 34.16,3.52 Z M33.952,7.952 L34.928,5.424 C37.52,5.696 40.384,6.288 43.728,7.264 L42.912,9.968 C41.504,9.424 40.288,9.072 38.272,8.64 C36.848,8.336 35.744,8.16 33.952,7.952 Z M32.624,12.48 L33.648,9.936 C37.6,10.368 40.832,11.072 44.656,12.32 L43.76,15.136 C41.92,14.384 40.32,13.904 37.84,13.344 C35.904,12.928 34.544,12.704 32.624,12.48 Z M64.1199999,1.104 L67.1759999,2.144 C66.9999999,2.512 66.8879999,2.816 66.5839999,3.616 C65.4799999,6.512 64.0239999,8.944 62.3279999,10.688 C60.8079999,12.256 58.9679999,13.536 56.4239999,14.816 C55.8319999,13.68 55.4479999,13.152 54.4079999,12.08 C56.8079999,11.136 58.3279999,10.208 59.8639999,8.768 C61.5599999,7.152 62.7919999,5.216 63.6719999,2.752 C63.9119999,2.032 64.0239999,1.664 64.1199999,1.104 Z M78.8959999,3.584 L81.1039999,3.584 C81.1519999,2.96 81.1839999,2.032 81.1839999,1.536 C81.1839999,1.2 81.1839999,1.072 81.1359999,0.736 L84.1439999,0.816 C84.0639999,1.184 84.0639999,1.232 83.9679999,2.752 C83.9519999,3.184 83.9519999,3.184 83.9199999,3.568 L87.4079999,3.568 C87.9359999,3.568 88.1279999,3.536 88.4799999,3.392 L89.7279999,4.48 C89.5519999,4.8 89.5199999,4.928 89.5039999,5.664 C89.3919999,9.088 89.1519999,11.76 88.8319999,12.816 C88.3679999,14.304 87.5999999,14.816 85.8239999,14.816 C85.1999999,14.816 84.9599999,14.8 83.7279999,14.688 C83.6639999,13.408 83.5519999,12.88 83.1839999,11.872 C83.9839999,12.08 84.7679999,12.192 85.2639999,12.192 C86.0319999,12.192 86.2239999,11.936 86.4319999,10.544 C86.5919999,9.472 86.7359999,7.456 86.7359999,6.08 L83.6799999,6.08 C83.5519999,7.136 83.5519999,7.136 83.4399999,7.68 C82.7359999,10.912 81.2159999,12.992 77.9679999,15.136 C77.2479999,14 76.7679999,13.456 75.8879999,12.704 C78.0159999,11.584 79.2479999,10.448 80.0479999,8.832 C80.4479999,8.016 80.6239999,7.44 80.8479999,6.096 L78.8479999,6.096 C77.7759999,6.096 77.4399999,6.112 76.6879999,6.192 L76.6719999,3.456 C77.4719999,3.568 77.7599999,3.584 78.8959999,3.584 Z M98.6159998,3.872 L100.456,1.616 C102.472,2.8 103.512,3.536 104.856,4.752 L102.968,7.248 C101.576,5.792 100.216,4.736 98.6159998,3.872 Z M99.6079998,14.624 L98.7759998,11.552 C100.408,11.424 102.088,11.024 103.592,10.4 C105.608,9.568 107.048,8.368 108.28,6.448 C108.952,5.424 109.384,4.544 109.848,3.312 C110.632,4.256 111,4.576 112.2,5.456 C110.744,8.608 109.224,10.496 106.984,11.936 C105.256,13.056 103.736,13.648 100.76,14.336 C100.136,14.48 100.04,14.496 99.6079998,14.624 Z M127.824,3.568 L131.136,3.568 C130.784,2.736 130.496,2.208 129.984,1.504 L131.568,0.992 C132.128,1.728 132.544,2.512 132.896,3.44 L132.48,3.6 L133.632,4.752 C133.456,5.072 133.44,5.168 133.408,5.92 C133.376,6.928 133.184,9.968 133.104,10.72 C132.864,12.784 132.56,13.696 131.872,14.256 C131.392,14.656 130.768,14.816 129.728,14.816 C129.088,14.816 128.928,14.8 127.632,14.688 C127.568,13.472 127.44,12.784 127.088,11.872 C127.888,12.08 128.672,12.192 129.168,12.192 C129.936,12.192 130.128,11.936 130.336,10.544 C130.496,9.472 130.64,7.472 130.64,6.08 L127.584,6.08 L127.552,6.4 L127.52,6.624 C126.976,10.448 125.408,12.8 121.872,15.136 C121.216,14.08 120.576,13.344 119.792,12.704 C122.848,11.152 124.336,9.152 124.752,6.096 L122.752,6.096 C121.664,6.096 121.328,6.112 120.592,6.192 L120.576,3.456 C121.312,3.568 121.712,3.584 122.8,3.584 L125.008,3.584 C125.056,2.96 125.088,2.032 125.088,1.536 C125.088,1.2 125.088,1.072 125.04,0.736 L128.048,0.816 C127.984,1.136 127.952,1.344 127.872,2.752 C127.856,3.136 127.856,3.216 127.824,3.568 Z M132.304,0.768 L133.808,0.272 C134.336,0.976 134.704,1.648 135.136,2.656 L133.616,3.216 C133.168,2.16 132.8,1.456 132.304,0.768 Z M150.584,4.896 L150.584,10.96 L153.688,10.96 C155.112,10.96 155.608,10.944 156.328,10.832 L156.328,13.648 C155.736,13.584 154.936,13.552 153.736,13.552 L144.712,13.552 C143.272,13.552 142.84,13.568 142.136,13.632 L142.136,10.832 C142.904,10.928 143.48,10.96 144.76,10.96 L147.672,10.96 L147.672,4.896 L145.912,4.896 C144.408,4.896 144.024,4.912 143.32,4.976 L143.32,2.208 C144.168,2.32 144.664,2.336 145.96,2.336 L152.472,2.336 C153.816,2.336 154.376,2.304 155.112,2.208 L155.112,4.976 C154.376,4.912 154.024,4.896 152.52,4.896 L150.584,4.896 Z" id="キミノカンガエ" fill="#000000"></path>
      </g>
  </svg> -->
  <!-- <svg class="logo-sub"  width="180px"  viewBox="0 0 172 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g   stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" fill-opacity="0.3">
          <path   d="M20.53,39.72 L18.66,35.62 C18.22,34.63 18.21,34.6 18.09,34.38 L19.61,34.38 C19.66,34.67 19.81,35.14 19.99,35.55 L21.21,38.39 L22.32,35.56 C22.56,34.95 22.64,34.7 22.7,34.38 L24.19,34.38 C24.13,34.51 23.95,34.92 23.65,35.62 L21.37,40.97 C21.05,41.73 20.46,42.08 19.53,42.08 C19.23,42.08 18.94,42.05 18.48,41.96 L18.71,40.82 C18.99,40.94 19.18,40.99 19.41,40.99 C19.76,40.99 20.05,40.8 20.19,40.49 L20.53,39.72 Z M27.65,40.31 C25.82,40.31 24.66,39.13 24.66,37.26 C24.66,35.4 25.82,34.21 27.64,34.21 C29.45,34.21 30.6,35.39 30.6,37.24 C30.6,39.09 29.43,40.31 27.65,40.31 Z M27.64,35.25 C26.59,35.25 25.95,36.01 25.95,37.26 C25.95,38.49 26.59,39.25 27.63,39.25 C28.67,39.25 29.31,38.5 29.31,37.28 C29.31,35.99 28.7,35.25 27.64,35.25 Z M35.64,34.38 L37.08,34.38 C37.01,34.81 37,35.12 37,35.68 L37,38.82 C37,39.37 37.02,39.71 37.08,40.12 L35.72,40.12 L35.72,39.59 C35.72,39.44 35.72,39.41 35.73,39.16 C35.18,39.94 34.63,40.23 33.68,40.23 C33.17,40.23 32.81,40.14 32.48,39.94 C31.93,39.59 31.67,39.03 31.67,38.21 L31.67,35.68 C31.67,35.13 31.64,34.75 31.59,34.38 L33.04,34.38 C32.98,34.83 32.97,35.17 32.97,35.68 L32.97,37.9 C32.97,38.48 33.12,38.85 33.43,39.04 C33.58,39.12 33.79,39.18 33.98,39.18 C34.7,39.18 35.27,38.69 35.72,37.7 L35.72,35.68 C35.72,35.19 35.69,34.81 35.64,34.38 Z M42.52,34.38 L42.17,35.64 C41.75,35.52 41.54,35.48 41.28,35.48 C40.78,35.48 40.4,35.64 40.12,35.97 C39.87,36.26 39.77,36.49 39.71,36.97 L39.71,38.82 C39.71,39.36 39.73,39.65 39.78,40.12 L38.35,40.12 C38.4,39.63 38.42,39.34 38.42,38.82 L38.42,35.68 C38.42,35.07 38.41,34.79 38.35,34.38 L39.71,34.38 L39.71,35.32 C40.07,34.61 40.69,34.27 41.59,34.27 C41.83,34.27 42.07,34.3 42.52,34.38 Z M47.25,32.84 L48.68,32.84 C48.64,33.19 48.61,33.62 48.61,34.07 L48.61,34.38 L49.03,34.38 C49.5,34.38 49.72,34.37 50.04,34.32 L50.04,35.5 C49.71,35.45 49.52,35.44 49.06,35.44 L48.61,35.44 L48.61,38.54 C48.61,39.03 48.79,39.21 49.27,39.21 C49.53,39.21 49.69,39.16 50,38.99 L50.18,40.05 C49.75,40.21 49.45,40.26 48.93,40.26 C47.78,40.26 47.32,39.85 47.32,38.8 L47.32,35.44 L46.94,35.44 C46.57,35.44 46.38,35.45 46.05,35.5 L46.05,34.32 C46.34,34.37 46.53,34.38 46.95,34.38 L47.32,34.38 L47.32,34.07 C47.32,33.64 47.29,33.2 47.25,32.84 Z M50.93,32.16 L52.35,32.16 C52.3,32.54 52.28,32.91 52.28,33.48 L52.28,34.91 C52.28,35.04 52.28,35.09 52.26,35.34 C52.88,34.56 53.42,34.28 54.33,34.28 C55.61,34.28 56.34,35.01 56.34,36.3 L56.34,38.82 C56.34,39.37 56.36,39.75 56.42,40.12 L54.97,40.12 C55.02,39.67 55.04,39.33 55.04,38.82 L55.04,36.6 C55.04,36.14 54.94,35.81 54.75,35.61 C54.57,35.42 54.33,35.32 54.06,35.32 C53.31,35.32 52.73,35.8 52.28,36.8 L52.28,38.82 C52.28,39.31 52.3,39.69 52.36,40.12 L50.92,40.12 C50.98,39.69 51,39.39 51,38.82 L51,33.47 C51,32.87 50.98,32.56 50.93,32.16 Z M57.65,32.16 L59.12,32.16 L59.12,33.43 L57.65,33.43 L57.65,32.16 Z M57.65,34.38 L59.11,34.38 C59.06,34.75 59.04,35.08 59.04,35.69 L59.04,38.81 C59.04,39.36 59.06,39.7 59.11,40.12 L57.65,40.12 C57.71,39.67 57.73,39.32 57.73,38.82 L57.73,35.68 C57.73,35.13 57.71,34.79 57.65,34.38 Z M61.8,40.12 L60.36,40.12 C60.42,39.69 60.44,39.38 60.44,38.82 L60.44,35.68 C60.44,35.13 60.42,34.79 60.36,34.38 L61.72,34.38 L61.72,34.91 C61.72,35.06 61.72,35.09 61.7,35.34 C62.31,34.56 62.84,34.28 63.74,34.28 C64.51,34.28 65.08,34.53 65.44,35.02 C65.68,35.35 65.78,35.75 65.78,36.42 L65.78,38.82 C65.78,39.37 65.8,39.75 65.86,40.12 L64.41,40.12 C64.46,39.67 64.48,39.33 64.48,38.82 L64.48,36.6 C64.48,36.18 64.43,35.91 64.31,35.72 C64.15,35.46 63.85,35.31 63.47,35.31 C62.75,35.31 62.16,35.81 61.72,36.8 L61.72,38.82 C61.72,39.31 61.74,39.69 61.8,40.12 Z M67.11,32.16 L68.52,32.16 C68.47,32.54 68.45,32.89 68.45,33.47 L68.45,36.76 L69.95,35.27 C70.41,34.83 70.58,34.63 70.74,34.38 L72.61,34.38 C72.04,34.89 72.04,34.89 71.61,35.3 L70.19,36.65 L71.88,38.96 C72.56,39.89 72.56,39.89 72.79,40.12 L71.01,40.12 C70.89,39.8 70.77,39.6 70.35,38.99 L69.27,37.41 L68.45,38.19 L68.45,38.84 C68.45,39.49 68.46,39.73 68.52,40.12 L67.11,40.12 C67.16,39.71 67.18,39.37 67.18,38.82 L67.18,33.47 C67.18,32.87 67.16,32.54 67.11,32.16 Z M73.36,38.49 L74.73,38.32 C74.9,39 75.27,39.27 76.05,39.27 C76.79,39.27 77.25,38.98 77.25,38.51 C77.25,38.31 77.15,38.12 76.99,38.01 C76.8,37.88 76.74,37.87 75.94,37.69 C75.15,37.52 74.84,37.42 74.5,37.26 C73.93,36.99 73.62,36.51 73.62,35.93 C73.62,35.58 73.73,35.25 73.93,35 C74.34,34.48 75.02,34.22 75.93,34.22 C76.75,34.22 77.4,34.42 77.81,34.8 C78.07,35.05 78.21,35.3 78.35,35.79 L77.03,35.96 C76.92,35.41 76.58,35.17 75.93,35.17 C75.31,35.17 74.89,35.45 74.89,35.87 C74.89,36.06 75,36.23 75.2,36.34 C75.42,36.45 75.63,36.51 76.2,36.64 C77.22,36.86 77.63,37 77.96,37.25 C78.35,37.53 78.54,37.94 78.54,38.49 C78.54,38.9 78.35,39.34 78.05,39.62 C77.59,40.05 76.89,40.27 75.98,40.27 C74.95,40.27 74.18,39.96 73.75,39.38 C73.57,39.14 73.48,38.94 73.36,38.49 Z M82.87,32.16 L84.34,32.16 L84.34,33.43 L82.87,33.43 L82.87,32.16 Z M82.87,34.38 L84.33,34.38 C84.28,34.75 84.26,35.08 84.26,35.69 L84.26,38.81 C84.26,39.36 84.28,39.7 84.33,40.12 L82.87,40.12 C82.93,39.67 82.95,39.32 82.95,38.82 L82.95,35.68 C82.95,35.13 82.93,34.79 82.87,34.38 Z M85.33,38.49 L86.7,38.32 C86.87,39 87.24,39.27 88.02,39.27 C88.76,39.27 89.22,38.98 89.22,38.51 C89.22,38.31 89.12,38.12 88.96,38.01 C88.77,37.88 88.71,37.87 87.91,37.69 C87.12,37.52 86.81,37.42 86.47,37.26 C85.9,36.99 85.59,36.51 85.59,35.93 C85.59,35.58 85.7,35.25 85.9,35 C86.31,34.48 86.99,34.22 87.9,34.22 C88.72,34.22 89.37,34.42 89.78,34.8 C90.04,35.05 90.18,35.3 90.32,35.79 L89,35.96 C88.89,35.41 88.55,35.17 87.9,35.17 C87.28,35.17 86.86,35.45 86.86,35.87 C86.86,36.06 86.97,36.23 87.17,36.34 C87.39,36.45 87.6,36.51 88.17,36.64 C89.19,36.86 89.6,37 89.93,37.25 C90.32,37.53 90.51,37.94 90.51,38.49 C90.51,38.9 90.32,39.34 90.02,39.62 C89.56,40.05 88.86,40.27 87.95,40.27 C86.92,40.27 86.15,39.96 85.72,39.38 C85.54,39.14 85.45,38.94 85.33,38.49 Z M96.75,39.72 L94.88,35.62 C94.44,34.63 94.43,34.6 94.31,34.38 L95.83,34.38 C95.88,34.67 96.03,35.14 96.21,35.55 L97.43,38.39 L98.54,35.56 C98.78,34.95 98.86,34.7 98.92,34.38 L100.41,34.38 C100.35,34.51 100.17,34.92 99.87,35.62 L97.59,40.97 C97.27,41.73 96.68,42.08 95.75,42.08 C95.45,42.08 95.16,42.05 94.7,41.96 L94.93,40.82 C95.21,40.94 95.4,40.99 95.63,40.99 C95.98,40.99 96.27,40.8 96.41,40.49 L96.75,39.72 Z M103.87,40.31 C102.04,40.31 100.88,39.13 100.88,37.26 C100.88,35.4 102.04,34.21 103.86,34.21 C105.67,34.21 106.82,35.39 106.82,37.24 C106.82,39.09 105.65,40.31 103.87,40.31 Z M103.86,35.25 C102.81,35.25 102.17,36.01 102.17,37.26 C102.17,38.49 102.81,39.25 103.85,39.25 C104.89,39.25 105.53,38.5 105.53,37.28 C105.53,35.99 104.92,35.25 103.86,35.25 Z M111.86,34.38 L113.3,34.38 C113.23,34.81 113.22,35.12 113.22,35.68 L113.22,38.82 C113.22,39.37 113.24,39.71 113.3,40.12 L111.94,40.12 L111.94,39.59 C111.94,39.44 111.94,39.41 111.95,39.16 C111.4,39.94 110.85,40.23 109.9,40.23 C109.39,40.23 109.03,40.14 108.7,39.94 C108.15,39.59 107.89,39.03 107.89,38.21 L107.89,35.68 C107.89,35.13 107.86,34.75 107.81,34.38 L109.26,34.38 C109.2,34.83 109.19,35.17 109.19,35.68 L109.19,37.9 C109.19,38.48 109.34,38.85 109.65,39.04 C109.8,39.12 110.01,39.18 110.2,39.18 C110.92,39.18 111.49,38.69 111.94,37.7 L111.94,35.68 C111.94,35.19 111.91,34.81 111.86,34.38 Z M118.74,34.38 L118.39,35.64 C117.97,35.52 117.76,35.48 117.5,35.48 C117,35.48 116.62,35.64 116.34,35.97 C116.09,36.26 115.99,36.49 115.93,36.97 L115.93,38.82 C115.93,39.36 115.95,39.65 116,40.12 L114.57,40.12 C114.62,39.63 114.64,39.34 114.64,38.82 L114.64,35.68 C114.64,35.07 114.63,34.79 114.57,34.38 L115.93,34.38 L115.93,35.32 C116.29,34.61 116.91,34.27 117.81,34.27 C118.05,34.27 118.29,34.3 118.74,34.38 Z M122.55,38.49 L123.92,38.32 C124.09,39 124.46,39.27 125.24,39.27 C125.98,39.27 126.44,38.98 126.44,38.51 C126.44,38.31 126.34,38.12 126.18,38.01 C125.99,37.88 125.93,37.87 125.13,37.69 C124.34,37.52 124.03,37.42 123.69,37.26 C123.12,36.99 122.81,36.51 122.81,35.93 C122.81,35.58 122.92,35.25 123.12,35 C123.53,34.48 124.21,34.22 125.12,34.22 C125.94,34.22 126.59,34.42 127,34.8 C127.26,35.05 127.4,35.3 127.54,35.79 L126.22,35.96 C126.11,35.41 125.77,35.17 125.12,35.17 C124.5,35.17 124.08,35.45 124.08,35.87 C124.08,36.06 124.19,36.23 124.39,36.34 C124.61,36.45 124.82,36.51 125.39,36.64 C126.41,36.86 126.82,37 127.15,37.25 C127.54,37.53 127.73,37.94 127.73,38.49 C127.73,38.9 127.54,39.34 127.24,39.62 C126.78,40.05 126.08,40.27 125.17,40.27 C124.14,40.27 123.37,39.96 122.94,39.38 C122.76,39.14 122.67,38.94 122.55,38.49 Z M134.11,37.58 L129.76,37.58 C129.81,38.13 129.9,38.41 130.13,38.7 C130.42,39.06 130.87,39.26 131.38,39.26 C131.87,39.26 132.29,39.08 132.58,38.76 C132.7,38.62 132.77,38.51 132.87,38.24 L134.05,38.62 C133.82,39.1 133.69,39.29 133.44,39.54 C132.92,40.05 132.22,40.31 131.38,40.31 C129.61,40.31 128.49,39.13 128.49,37.26 C128.49,35.41 129.6,34.2 131.31,34.2 C132.48,34.2 133.4,34.78 133.8,35.78 C133.99,36.26 134.06,36.62 134.09,37.3 C134.09,37.32 134.09,37.35 134.11,37.58 Z M129.79,36.59 L132.81,36.59 C132.74,36.15 132.62,35.88 132.37,35.63 C132.1,35.36 131.76,35.23 131.29,35.23 C130.51,35.23 129.94,35.75 129.79,36.59 Z M135.1,32.16 L136.55,32.16 C136.5,32.55 136.48,32.87 136.48,33.47 L136.48,38.82 C136.48,39.35 136.5,39.68 136.55,40.12 L135.1,40.12 C135.15,39.69 135.17,39.4 135.17,38.82 L135.17,33.46 C135.17,32.86 135.15,32.54 135.1,32.16 Z M138.64,35.43 L138.24,35.43 C137.86,35.43 137.6,35.45 137.29,35.49 L137.29,34.32 C137.57,34.36 137.87,34.38 138.23,34.38 L138.64,34.38 L138.64,33.85 C138.64,32.61 139.27,32.03 140.63,32.03 C141.08,32.03 141.41,32.08 141.87,32.23 L141.6,33.28 C141.3,33.11 141.05,33.04 140.71,33.04 C140.13,33.04 139.93,33.28 139.93,33.97 L139.93,34.38 L140.4,34.38 C140.8,34.38 141.11,34.36 141.53,34.32 L141.53,35.49 C141.18,35.45 140.91,35.43 140.42,35.43 L139.93,35.43 L139.93,38.82 C139.93,39.39 139.95,39.68 140,40.12 L138.57,40.12 C138.62,39.65 138.64,39.34 138.64,38.82 L138.64,35.43 Z" id="your-thinks-is-your" fill="#000000"></path>
      </g>
  </svg> -->
</div>

 <!-- ===========================
      ユーザー情報 
      ===========================-->
      <div class="container" >
        <el-tooltip class="item" :value="true" :disabled="!IsAnonymous" effect="dark" content="CLick > プロフィールから「アカウント登録」できます！" placement="bottom">
        <div v-show="isLogin" class="login_container">
          <span class="label">なまえ</span>
          <el-dropdown class="c-loginuser-info"  trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="fas fa-user-circle"></i> <span class="name-body">{{userName}}</span><span class="name-tail">さん</span><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <!-- ツールチップ部分 -->
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">プロフィール</el-dropdown-item>
              <!-- <el-dropdown-item command="settings">設定変更</el-dropdown-item> -->
              <el-dropdown-item divided　command="logout"> ログアウト</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        </el-tooltip>
      </div>


</div>


 <!-- ===========================
      ロゴ：ログイン画面時表示
      ===========================-->
  <div  @click="ToLandingPage" v-if="$route.name==='login-home' || $route.name==='login-phone'" class="container-login-logo">


        <div class="logo-sub-text"> <ruby>
          <rb>T字型思考法</rb>
          <rt>ティーじがたしこうほう</rt>
        </ruby>アプリ</div>

       <!-- <img class="gp-img" src="./assets/images/gp-001.svg"  > -->
        <img class="logo-soeji-img" src="./assets/images/txt-logosoeji.svg"  >
        <img class="logo-img" src="./assets/images/logo-kidstthink.svg"  >

        <img class="cara-img" src="./assets/images/cara-001.svg" > 

          <!-- <img class="illust-img" src="./assets/images/illust-001-think.svg"  > -->

       
       
        
      <!-- <img class="child-img" src="./assets/illust-001-think.svg"  > -->
 
   
  </div>

 <!-- ===========================
      ロゴ：ログイン画面時表示
      ===========================-->
  <!-- <div v-if="$route.name==='login-home' || $route.name==='login-phone'" class="title-container">

    <div class="title-base">
      <div class="left-side-content">
         <img class="child-img" src="./assets/child2.svg"  >
      </div>
        <div class="right-side-content">
          
           <img class="logo-text" src="./assets/images/logo_text.svg"  >
          <div class="row"></div>
          <div class="row"></div>
          <div class="row"></div>
          
        </div>
    </div>
  </div> -->

     
  <!-- ===========================
      メイン
      ===========================-->
 <transition name="slide-fade" mode="out-in" >
    <router-view class="main-view" />
 </transition>



<!-- ===========================
      ツール：ダイアログ
      ===========================-->
 <t-dialog :show="showModal" @ok="ModalCallback('ok')" @cancel="ModalCallback('cancel')">
    <template slot="header" >
      <i class="fa  fa-exclamation-circle " style="display: inline-block; margin-right: 5px;font-size:18px;">&nbsp;</i>
    設定変更
</template>
  <template slot="body" >
    <!-- <profile-page-component style="width:600px;"></profile-page-component> -->
  </template>
 </t-dialog>


<!-- ===========================
      フッター：ログイン時のみ表示
      ===========================-->
 <footer v-if="$route.path==='/login'" class="footer-container">
     <div class="copyright">
        © 2019 KidsTThink , Created by  ISHIMARU App. Thanks.
     </div>
  </footer>

<div class="version" title="version">version {{version}}</div>
</div>
</template>

<script>
import TDialog from "./components/TDialog";
import ProfilePage from "./components/pages/ProfilePage";

export default {
  name: "App",
  components: {
    TDialog,
    "profile-page-component": ProfilePage
  },
  data() {
    return {
      showModal: false,
      version:""
    };
  },
  created() {
    //versionチェック
    //相違があれば画面をリロードする
    this.$store
      .dispatch("GetAppVersion")
      .then(res => {
        var version = res.version;
        var versionCookies = this.$cookies.get("kidstthink.version") || '';
        this.$cookies.set("kidstthink.version",version,60 * 60 * 24 * 30) // 期限一ヶ月
        this.version = version;
        if (version != versionCookies) {
          window.navigator.serviceWorker
            .getRegistrations()
            .then(registrations => {
              for (let registration of registrations) {
                registration.unregister();
              }
            });
          window.location.reload(true);
        }
      })
      .catch(error => {
        //何もしない
      });
  },
  computed: {
    userName() {
      return this.LoginUser.displayName;
    },
    IsAnonymous() {
      if (this.$store.getters.loginUser === null) {
        return false;
      }
      return this.$store.getters.loginUser.isAnonymous;
    },
    LoginUser() {
      return this.$store.getters.User;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    }
  },
  methods: {
    ModalCallback(text) {
      this.showModal = false;
    },
    //ランディングページへ遷移
    ToLandingPage() {
      this.$router.push({ name: "LandingPage" });
    },
    // //==========================
    // //判定：現在のページがログイン画面か？
    // //==========================
    // IsLoginPage(){
    //   if(this.$route.path==="/login")
    //   {
    //     return true;
    //   }
    //   return false;

    // },
    //==========================
    //ログアウト処理
    //==========================
    LogOut() {
      if (this.IsAnonymous) {
        this.$confirm(
          "<strong>おためしモードでログアウトすると登録したデータはすべて削除されます。よろしいですか?</strong><p>※データを残す場合はアカウント登録をご検討いただけるとうれしいです。</p>",
          "確認",
          {
            confirmButtonText: "はい",
            dangerouslyUseHTMLString: true,
            cancelButtonText: "いいえ",
            type: "warning"
          }
        )
          .then(() => {
            this.$store.commit("AnonymousLogout");
          })
          .catch(() => {
            //キャンセル時の処理
          });

        return;
      }

      this.$store.commit("Logout");
    },
    handleCommand(command) {
      if (command === "logout") {
        this.LogOut();
        return;
      }

      if (command === "profile") {
        this.$router.push({ name: "ProfilePage" });
        return;
      }

      if (command === "settings") {
        this.showModal = true;
        return;
      }
    }
  }
};
</script>


<style scoped　lang="scss" >
@import "./assets/style/common.scss";

//===========================
//ルートコンテナー
//===========================
.app-container {
  font-family: "Avenir", Helvetica, Arial, "Rounded Mplus 1c", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;

  position: relative;
  padding-top: 0px;
  width: 100%;
  box-sizing: border-box;
  margin: 0;

  //画面大=幅固定+中央配置
  @include mq-up(xl) {
    width: 1200px;
    margin: auto;
  }
  @include mq-up(lg) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @include mq-down(lg) {
    //background:yellow;
    padding-left: 30px;
    padding-right: 30px;
  }

  @include mq-down(md) {
    //background:yellow;
    padding-left: 10px;
    padding-right: 10px;
  }

  @include mq-down(sm) {
    //background:#A6A9A9	;
    padding-top: 30px;
  }
}

.header-bar {
  position: relative;
  //border:1px solid orange;
  height: 80px;
}

.logo-big {
  position: absolute;
  margin-top: 10px;
  transform: scale(1.5);
}

.logo {
  width: 160px;
}

//===========================
//
//===========================
.logo-sub {
  position: absolute;
  left: 10px;
  top: 48px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5em;
  opacity: 0.7;
}

//===========================
//コンテナ：ロゴ部分
//===========================
.mini-title-container {
  position: absolute;
  top: 6px;
  left: 0px;

  @include mq-down(md) {
    left: 13px;
  }
}

//===========================
//コンテナ：ロゴ
//===========================
.container-login-logo {
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  max-width: 500px;
  //height:90px;
  margin: auto; //中央配置
  // border:1px solid gray;
  position: relative;
  align-items: start;

  //--sm
  @include mq-down(md) {
    // max-height:90px;
    //height:240px;
  }

  //--------------
  //ロゴ画像
  & > .logo-img {
    width: 320px;

    margin-top: 0px;
    margin-left: auto;
    margin-right: auto;
    //height:50px;
    // border:1px solid orange;

    @include mq-down(md) {
      width: 300px;
    }
  }

  & > .cara-img {
    width: 90px;
    margin: auto;
  }
  //--------------
  //illust画像
  & > .illust-img {
    transform: scale(1);

    position: absolute;
    top: 40px;
    left: 0px;

    @include mq-down(md) {
      left: 20px;
      transform: scale(0.9);
    }
  }

  & > .logo-soeji-img {
    margin: auto;
    margin-top: 20px;
    width: 200px;
  }

  //--------------
  //図-画像
  & > .gp-img {
    position: absolute;
    top: 100px;
    left: 120px;
  }
  //--------------
  //テキスト
  & > .logo-sub-text {
    font-size: 18px;
    font-weight: 900;
    margin: auto;

    color: #573f23;

    letter-spacing: 0.88em;

    color: white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #573f23;
    text-shadow: 1px 2px 0px #573f23;

    & > ruby > rt {
      -webkit-text-stroke-width: 0px;
      color: #573f23;
      letter-spacing: 0.68em;
      text-shadow: none;
    }

    @include mq-down(md) {
      font-size: 16px;
    }
  }
}

//===========================
//
//===========================
.title-container {
  text-align: center;
  display: flex;
  max-width: 500px;
  max-height: 160px;
  margin: auto; //中央配置
  background: yellow;

  //--sm
  @include mq-down(sm) {
    max-height: 130px;
  }

  & > .title-base {
    display: flex;
    align-items: stretch;
    border: 3px solid #333;
    position: relative;
    width: 100%;

    .logo {
      position: absolute;
      right: 45px;
      top: 10px;
    }

    //----------------------
    //ロゴ：左コンテンツ
    //----------------------
    .left-side-content {
      display: flex;
      justify-content: center; //中のコンテンツを中央
      align-items: center;
      width: 30%;

      background: white;
      border-right: 1px solid #333;

      & .child-img {
        width: 70%;
        height: 80%;
      }

      @include mq-down(sm) {
        width: 40%;
        flex: 0 0 90px;
      }
    }

    //----------------------
    //ロゴ：右コンテンツ
    //----------------------
    .right-side-content {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      position: relative;
      background: white;

      @include mq-down(sm) {
        flex: 1 1 auto;
      }

      & > .logo-text {
        width: 85%;
        left: 20px;
        top: 15px;
        height: 80%;
        margin: auto;
        position: absolute;

        @include mq-down(sm) {
          width: 95%;
          left: 5px;
          top: 15px;
          margin: auto;
          position: absolute;
        }
      }

      .row {
        height: 48px;

        &:not(:last-child) {
          border-bottom: 1px solid #666;
        }
      }
    }
  }
}

//===========================
//
//===========================
.container {
  position: absolute;
  top: 15px;
  right: 0px;
  display: flex;
  align-items: stretch;
  flex-direction: row;
  justify-content: flex-end;
}

//---------------
// コンテナ: ログインユーザー表示部分
//---------------
//===========================
//
//===========================
.login_container {
  display: flex;
  background: #fff;
  align-items: center;
  border: 2px solid #666;

  .label {
    letter-spacing: 0.08em;
    font-weight: 600;
    border-right: 1px solid #666;
    padding: 3px 18px;
    //縁取り文字
    color: #fff;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: #666;

    @include mq-down(md) {
      display: none;
    }
  }

  .c-loginuser-info {
    padding-left: 18px;
    padding-right: 10px;
    color: #666;
    font-size: 16px;
    outline-width: 0;
    &:focus {
      outline: none;
    }
    cursor: pointer;
    &:hover {
      color: coral;
    }

    @include mq-down(md) {
      padding-left: 8px;
      padding-right: 5px;
    }
  }

  .name-body {
    margin-left: 5px;
    letter-spacing: 0.08em;
    @include mq-down(md) {
      // 引数を個別に指定
      font-size: 12px;
    }
  }
  .name-tail {
    margin-left: 3px;
    font-size: 12px;
    @include mq-down(md) {
      // 引数を個別に指定
      font-size: 10px;
    }
  }
}

//===========================
//
//===========================
/* 要素が挿入される前に適用され、要素が挿入された 1 フレーム後に削除されます。 */
.slide-fade-enter-active {
  transition: all 0.2s;
}
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter {
  transform: translateX(-30px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

//===========================
//
//===========================
.el-dropdown-menu__item {
  &:hover {
    background: #e2f8ee;
    color: #39af78;
  }
}

//===========================
//
//===========================
.main-view {
  //background:yellow;
  //padding-bottom:40px; //フッター分の余白です
}

//===========================
//コンテナ: フッター
//===========================
.footer-container {
  display: flex;
  height: 40px;
  justify-content: center;
  width: 100%;
  align-items: center;
  position: absolute; /* 絶対位置指定することを定義 */
  bottom: 0px; /* 絶対位置指定(左0px,下0px) */
  & > .copyright {
    display: inline-block;
    text-align: center;
    font-size: 12px;
    color: #333;
  }
}

.version{
  position:absolute;
  top:0;
  color:Gray;
  font-size:8px;
  right:5px;
  top:2px;
  z-index:9999;
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue